import React, { useMemo } from 'react';
import styled from 'styled-components';
import { COMPACT_NODE_WIDTH } from '../FunctionFlowChart/FunctionFlowChart';

const FlowChartHeaderContainer = styled.div<{ nodeWidth: string }>`
  display: flex;
  justify-content: space-between;
  margin: 0 0px 6px 6px;
  font-size: 11px;

  & > div {
    width: ${({ nodeWidth }) => nodeWidth};
  }

  & > div:first-child {
    padding-left: 6px;
  }

  & > div:last-child {
    text-align: left;
  }
`;

const FlowChartPreviewHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 6px 0;
  font-size: 11px;

  & > div:first-child {
    flex: 1;
  }

  & > div:last-child {
    text-align: right;
  }
`;

interface FlowChartHeaderProps {
  callers: number;
  callees: number;

  hideTitleIfEmpty?: boolean;
  nodeWidth?: string;
}

export function FlowChartHeader({
  callers,
  callees,
  hideTitleIfEmpty,
  nodeWidth = COMPACT_NODE_WIDTH,
  ...rest
}: FlowChartHeaderProps) {
  if (callers === 0 && callees === 0) {
    return null;
  }

  const callerText = useMemo(() => {
    if (hideTitleIfEmpty && callers === 0) {
      return '';
    }
    return `${callers} ${callers === 1 ? 'Caller' : 'Callers'}`;
  }, [callers]);

  const calleesText = useMemo(() => {
    if (hideTitleIfEmpty && callees === 0) {
      return '';
    }
    return `${callees} ${callees === 1 ? 'Callee' : 'Callees'}`;
  }, [callees]);

  return (
    <FlowChartHeaderContainer nodeWidth={nodeWidth} {...rest}>
      <div>{callerText}</div>
      <div>{calleesText}</div>
    </FlowChartHeaderContainer>
  );
}

export function FlowChartPreviewHeader({
  callers,
  callees,
}: FlowChartHeaderProps) {
  if (callers === 0 && callees === 0) {
    return null;
  }

  return (
    <FlowChartPreviewHeaderContainer>
      <div>{`${callers} ${callers === 1 ? 'Caller' : 'Callers'}`}</div>
      <div>{`${callees} ${callees === 1 ? 'Callee' : 'Callees'}`}</div>
    </FlowChartPreviewHeaderContainer>
  );
}
